<template>
  <div style="height: 100%">
    <material-card
      color="#68c6b3"
      title="Where your customers have chosen to impact"
      offset="0"
      style="height: 100%"
    >
      <v-layout justify-center wrap v-if="stats != undefined">
        <v-flex>
          <p style="font-weight: bold" class="my-0">
            This graph indicates where your customers have chosen to impact from
            your sales
          </p>
        </v-flex>
        <v-flex xs12>
          <apexChart
            height="300px"
            :options="upstreamStatusChartOptions"
            :series="upstreamStatusSeries"
          ></apexChart>
        </v-flex>

        <v-flex xs12 style="text-align: center">
          <p
            style="
              color: #325181;
              font-weight: bold;
              font-size: 25pt !important;
            "
            class="mb-0"
          >
            {{ calculateHrs() }}
          </p>
          <p
            style="
              color: #325181;
              font-size: 15pt !important;
              max-width: 300px;
              margin: auto;
            "
          >
            Equivalent hours of generated community work
          </p>
        </v-flex>
      </v-layout>
    </material-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import apexChart from "@/components/wrappers/apexChart.vue";

export default {
  props: ["contributions"],
  components: { apexChart },
  data: () => ({
    upstreamStatusSeries: [],
    upstreamStatusChartOptions: {
      chart: {
        type: "pie",
      },
      fill: {},
      colors: ["#325181", "#feb019", "#68c6b3", "#58595b", "#b276b2"],
      labels: [],
      legend: {
        position: "bottom",
      },
      tooltip: {
        y: {
          formatter: function (val) {
            let formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
            });
            return formatter.format(val);
          },
        },
      },
    },
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      stats: "stats/supplierGoodCauseCCStats",
    }),
  },
  watch: {
    stats: function () {
      this.updateGraphs();
    },
  },
  mounted() {
    this.$store
      .dispatch("stats/loadSupplierGoodCauseCC", this.userData.business_id)
      .then(() => {
        this.updateGraphs();
      });
  },
  methods: {
    updateGraphs() {
      this.upstreamStatusSeries = [];
      this.upstreamStatusChartOptions = {
        chart: {
          type: "pie",
        },
        colors: [
          "#325181",
          "#4cc7e8",
          "#68c6b3",
          "#58595b",
          "#feb019",
          "#b276b2",
        ],
        labels: [],
        legend: {
          position: "bottom",
        },
        tooltip: {
          y: {
            formatter: function (val) {
              let formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
              });
              return formatter.format(val);
            },
          },
        },
      };
      if (this.stats != undefined) {
        this.stats.forEach((type) => {
          this.upstreamStatusSeries.push(parseFloat(type.totalCC));
          this.upstreamStatusChartOptions.labels.push(
            type.type != "" ? type.type : "Impacts Overall"
          );
        });
      }
    },
    formatMoney(amount) {
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    calculateHrs() {
      if (this.contributions != "") {
        return (
          this.calculateCommunityHrs(this.contributions) + "hrs"
        );
      } else {
        return "0hrs";
      }
    },
  },
  filters: {
    moment: function (date) {
      return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
#statsModule h4.title.font-weight-light.mb-2 {
  font-weight: bold !important;
}
</style>